// Country Battle game data - countries, themes, and settings

const DEFAULT_COUNTRIES = [
  // ── ASIA ──
  { id: 'india', name: 'INDIA', flag: 'https://flagcdn.com/w160/in.png', code: 'IN' },
  { id: 'pakistan', name: 'PAKISTAN', flag: 'https://flagcdn.com/w160/pk.png', code: 'PK' },
  { id: 'bangladesh', name: 'BANGLADESH', flag: 'https://flagcdn.com/w160/bd.png', code: 'BD' },
  { id: 'sri-lanka', name: 'SRI LANKA', flag: 'https://flagcdn.com/w160/lk.png', code: 'LK' },
  { id: 'nepal', name: 'NEPAL', flag: 'https://flagcdn.com/w160/np.png', code: 'NP' },
  { id: 'bhutan', name: 'BHUTAN', flag: 'https://flagcdn.com/w160/bt.png', code: 'BT' },
  { id: 'afghanistan', name: 'AFGHANISTAN', flag: 'https://flagcdn.com/w160/af.png', code: 'AF' },
  { id: 'china', name: 'CHINA', flag: 'https://flagcdn.com/w160/cn.png', code: 'CN' },
  { id: 'japan', name: 'JAPAN', flag: 'https://flagcdn.com/w160/jp.png', code: 'JP' },
  { id: 'south-korea', name: 'SOUTH KOREA', flag: 'https://flagcdn.com/w160/kr.png', code: 'KR' },
  { id: 'north-korea', name: 'NORTH KOREA', flag: 'https://flagcdn.com/w160/kp.png', code: 'KP' },
  { id: 'indonesia', name: 'INDONESIA', flag: 'https://flagcdn.com/w160/id.png', code: 'ID' },
  { id: 'malaysia', name: 'MALAYSIA', flag: 'https://flagcdn.com/w160/my.png', code: 'MY' },
  { id: 'philippines', name: 'PHILIPPINES', flag: 'https://flagcdn.com/w160/ph.png', code: 'PH' },
  { id: 'thailand', name: 'THAILAND', flag: 'https://flagcdn.com/w160/th.png', code: 'TH' },
  { id: 'vietnam', name: 'VIETNAM', flag: 'https://flagcdn.com/w160/vn.png', code: 'VN' },
  { id: 'myanmar', name: 'MYANMAR', flag: 'https://flagcdn.com/w160/mm.png', code: 'MM' },
  { id: 'cambodia', name: 'CAMBODIA', flag: 'https://flagcdn.com/w160/kh.png', code: 'KH' },
  { id: 'laos', name: 'LAOS', flag: 'https://flagcdn.com/w160/la.png', code: 'LA' },
  { id: 'singapore', name: 'SINGAPORE', flag: 'https://flagcdn.com/w160/sg.png', code: 'SG' },
  { id: 'brunei', name: 'BRUNEI', flag: 'https://flagcdn.com/w160/bn.png', code: 'BN' },
  { id: 'timor-leste', name: 'TIMOR-LESTE', flag: 'https://flagcdn.com/w160/tl.png', code: 'TL' },
  { id: 'mongolia', name: 'MONGOLIA', flag: 'https://flagcdn.com/w160/mn.png', code: 'MN' },
  { id: 'taiwan', name: 'TAIWAN', flag: 'https://flagcdn.com/w160/tw.png', code: 'TW' },
  { id: 'saudi-arabia', name: 'SAUDI ARABIA', flag: 'https://flagcdn.com/w160/sa.png', code: 'SA' },
  { id: 'uae', name: 'UAE', flag: 'https://flagcdn.com/w160/ae.png', code: 'AE' },
  { id: 'iran', name: 'IRAN', flag: 'https://flagcdn.com/w160/ir.png', code: 'IR' },
  { id: 'iraq', name: 'IRAQ', flag: 'https://flagcdn.com/w160/iq.png', code: 'IQ' },
  { id: 'turkey', name: 'TURKEY', flag: 'https://flagcdn.com/w160/tr.png', code: 'TR' },
  { id: 'israel', name: 'ISRAEL', flag: 'https://flagcdn.com/w160/il.png', code: 'IL' },
  { id: 'jordan', name: 'JORDAN', flag: 'https://flagcdn.com/w160/jo.png', code: 'JO' },
  { id: 'lebanon', name: 'LEBANON', flag: 'https://flagcdn.com/w160/lb.png', code: 'LB' },
  { id: 'syria', name: 'SYRIA', flag: 'https://flagcdn.com/w160/sy.png', code: 'SY' },
  { id: 'yemen', name: 'YEMEN', flag: 'https://flagcdn.com/w160/ye.png', code: 'YE' },
  { id: 'oman', name: 'OMAN', flag: 'https://flagcdn.com/w160/om.png', code: 'OM' },
  { id: 'qatar', name: 'QATAR', flag: 'https://flagcdn.com/w160/qa.png', code: 'QA' },
  { id: 'kuwait', name: 'KUWAIT', flag: 'https://flagcdn.com/w160/kw.png', code: 'KW' },
  { id: 'bahrain', name: 'BAHRAIN', flag: 'https://flagcdn.com/w160/bh.png', code: 'BH' },
  { id: 'palestine', name: 'PALESTINE', flag: 'https://flagcdn.com/w160/ps.png', code: 'PS' },
  { id: 'kazakhstan', name: 'KAZAKHSTAN', flag: 'https://flagcdn.com/w160/kz.png', code: 'KZ' },
  { id: 'uzbekistan', name: 'UZBEKISTAN', flag: 'https://flagcdn.com/w160/uz.png', code: 'UZ' },
  { id: 'turkmenistan', name: 'TURKMENISTAN', flag: 'https://flagcdn.com/w160/tm.png', code: 'TM' },
  { id: 'tajikistan', name: 'TAJIKISTAN', flag: 'https://flagcdn.com/w160/tj.png', code: 'TJ' },
  { id: 'kyrgyzstan', name: 'KYRGYZSTAN', flag: 'https://flagcdn.com/w160/kg.png', code: 'KG' },
  { id: 'azerbaijan', name: 'AZERBAIJAN', flag: 'https://flagcdn.com/w160/az.png', code: 'AZ' },
  { id: 'armenia', name: 'ARMENIA', flag: 'https://flagcdn.com/w160/am.png', code: 'AM' },
  { id: 'georgia-country', name: 'GEORGIA', flag: 'https://flagcdn.com/w160/ge.png', code: 'GE' },
  { id: 'cyprus', name: 'CYPRUS', flag: 'https://flagcdn.com/w160/cy.png', code: 'CY' },
  { id: 'maldives', name: 'MALDIVES', flag: 'https://flagcdn.com/w160/mv.png', code: 'MV' },

  // ── EUROPE ──
  { id: 'england', name: 'ENGLAND', flag: 'https://flagcdn.com/w160/gb-eng.png', code: 'GB-ENG' },
  { id: 'scotland', name: 'SCOTLAND', flag: 'https://flagcdn.com/w160/gb-sct.png', code: 'GB-SCT' },
  { id: 'germany', name: 'GERMANY', flag: 'https://flagcdn.com/w160/de.png', code: 'DE' },
  { id: 'france', name: 'FRANCE', flag: 'https://flagcdn.com/w160/fr.png', code: 'FR' },
  { id: 'spain', name: 'SPAIN', flag: 'https://flagcdn.com/w160/es.png', code: 'ES' },
  { id: 'italy', name: 'ITALY', flag: 'https://flagcdn.com/w160/it.png', code: 'IT' },
  { id: 'netherlands', name: 'NETHERLANDS', flag: 'https://flagcdn.com/w160/nl.png', code: 'NL' },
  { id: 'portugal', name: 'PORTUGAL', flag: 'https://flagcdn.com/w160/pt.png', code: 'PT' },
  { id: 'ireland', name: 'IRELAND', flag: 'https://flagcdn.com/w160/ie.png', code: 'IE' },
  { id: 'russia', name: 'RUSSIA', flag: 'https://flagcdn.com/w160/ru.png', code: 'RU' },
  { id: 'ukraine', name: 'UKRAINE', flag: 'https://flagcdn.com/w160/ua.png', code: 'UA' },
  { id: 'poland', name: 'POLAND', flag: 'https://flagcdn.com/w160/pl.png', code: 'PL' },
  { id: 'belgium', name: 'BELGIUM', flag: 'https://flagcdn.com/w160/be.png', code: 'BE' },
  { id: 'sweden', name: 'SWEDEN', flag: 'https://flagcdn.com/w160/se.png', code: 'SE' },
  { id: 'norway', name: 'NORWAY', flag: 'https://flagcdn.com/w160/no.png', code: 'NO' },
  { id: 'denmark', name: 'DENMARK', flag: 'https://flagcdn.com/w160/dk.png', code: 'DK' },
  { id: 'finland', name: 'FINLAND', flag: 'https://flagcdn.com/w160/fi.png', code: 'FI' },
  { id: 'switzerland', name: 'SWITZERLAND', flag: 'https://flagcdn.com/w160/ch.png', code: 'CH' },
  { id: 'austria', name: 'AUSTRIA', flag: 'https://flagcdn.com/w160/at.png', code: 'AT' },
  { id: 'czech-republic', name: 'CZECH REPUBLIC', flag: 'https://flagcdn.com/w160/cz.png', code: 'CZ' },
  { id: 'hungary', name: 'HUNGARY', flag: 'https://flagcdn.com/w160/hu.png', code: 'HU' },
  { id: 'romania', name: 'ROMANIA', flag: 'https://flagcdn.com/w160/ro.png', code: 'RO' },
  { id: 'greece', name: 'GREECE', flag: 'https://flagcdn.com/w160/gr.png', code: 'GR' },
  { id: 'serbia', name: 'SERBIA', flag: 'https://flagcdn.com/w160/rs.png', code: 'RS' },
  { id: 'croatia', name: 'CROATIA', flag: 'https://flagcdn.com/w160/hr.png', code: 'HR' },
  { id: 'slovakia', name: 'SLOVAKIA', flag: 'https://flagcdn.com/w160/sk.png', code: 'SK' },
  { id: 'bulgaria', name: 'BULGARIA', flag: 'https://flagcdn.com/w160/bg.png', code: 'BG' },
  { id: 'belarus', name: 'BELARUS', flag: 'https://flagcdn.com/w160/by.png', code: 'BY' },
  { id: 'albania', name: 'ALBANIA', flag: 'https://flagcdn.com/w160/al.png', code: 'AL' },
  { id: 'north-macedonia', name: 'NORTH MACEDONIA', flag: 'https://flagcdn.com/w160/mk.png', code: 'MK' },
  { id: 'bosnia', name: 'BOSNIA & HERZ.', flag: 'https://flagcdn.com/w160/ba.png', code: 'BA' },
  { id: 'slovenia', name: 'SLOVENIA', flag: 'https://flagcdn.com/w160/si.png', code: 'SI' },
  { id: 'montenegro', name: 'MONTENEGRO', flag: 'https://flagcdn.com/w160/me.png', code: 'ME' },
  { id: 'moldova', name: 'MOLDOVA', flag: 'https://flagcdn.com/w160/md.png', code: 'MD' },
  { id: 'latvia', name: 'LATVIA', flag: 'https://flagcdn.com/w160/lv.png', code: 'LV' },
  { id: 'lithuania', name: 'LITHUANIA', flag: 'https://flagcdn.com/w160/lt.png', code: 'LT' },
  { id: 'estonia', name: 'ESTONIA', flag: 'https://flagcdn.com/w160/ee.png', code: 'EE' },
  { id: 'iceland', name: 'ICELAND', flag: 'https://flagcdn.com/w160/is.png', code: 'IS' },
  { id: 'luxembourg', name: 'LUXEMBOURG', flag: 'https://flagcdn.com/w160/lu.png', code: 'LU' },
  { id: 'malta', name: 'MALTA', flag: 'https://flagcdn.com/w160/mt.png', code: 'MT' },
  { id: 'andorra', name: 'ANDORRA', flag: 'https://flagcdn.com/w160/ad.png', code: 'AD' },
  { id: 'monaco', name: 'MONACO', flag: 'https://flagcdn.com/w160/mc.png', code: 'MC' },
  { id: 'liechtenstein', name: 'LIECHTENSTEIN', flag: 'https://flagcdn.com/w160/li.png', code: 'LI' },
  { id: 'san-marino', name: 'SAN MARINO', flag: 'https://flagcdn.com/w160/sm.png', code: 'SM' },
  { id: 'kosovo', name: 'KOSOVO', flag: 'https://flagcdn.com/w160/xk.png', code: 'XK' },
  { id: 'united-kingdom', name: 'UNITED KINGDOM', flag: 'https://flagcdn.com/w160/gb.png', code: 'GB' },

  // ── AMERICAS ──
  { id: 'usa', name: 'USA', flag: 'https://flagcdn.com/w160/us.png', code: 'US' },
  { id: 'canada', name: 'CANADA', flag: 'https://flagcdn.com/w160/ca.png', code: 'CA' },
  { id: 'mexico', name: 'MEXICO', flag: 'https://flagcdn.com/w160/mx.png', code: 'MX' },
  { id: 'brazil', name: 'BRAZIL', flag: 'https://flagcdn.com/w160/br.png', code: 'BR' },
  { id: 'argentina', name: 'ARGENTINA', flag: 'https://flagcdn.com/w160/ar.png', code: 'AR' },
  { id: 'colombia', name: 'COLOMBIA', flag: 'https://flagcdn.com/w160/co.png', code: 'CO' },
  { id: 'chile', name: 'CHILE', flag: 'https://flagcdn.com/w160/cl.png', code: 'CL' },
  { id: 'peru', name: 'PERU', flag: 'https://flagcdn.com/w160/pe.png', code: 'PE' },
  { id: 'venezuela', name: 'VENEZUELA', flag: 'https://flagcdn.com/w160/ve.png', code: 'VE' },
  { id: 'ecuador', name: 'ECUADOR', flag: 'https://flagcdn.com/w160/ec.png', code: 'EC' },
  { id: 'bolivia', name: 'BOLIVIA', flag: 'https://flagcdn.com/w160/bo.png', code: 'BO' },
  { id: 'paraguay', name: 'PARAGUAY', flag: 'https://flagcdn.com/w160/py.png', code: 'PY' },
  { id: 'uruguay', name: 'URUGUAY', flag: 'https://flagcdn.com/w160/uy.png', code: 'UY' },
  { id: 'cuba', name: 'CUBA', flag: 'https://flagcdn.com/w160/cu.png', code: 'CU' },
  { id: 'jamaica', name: 'JAMAICA', flag: 'https://flagcdn.com/w160/jm.png', code: 'JM' },
  { id: 'haiti', name: 'HAITI', flag: 'https://flagcdn.com/w160/ht.png', code: 'HT' },
  { id: 'dominican-republic', name: 'DOMINICAN REP.', flag: 'https://flagcdn.com/w160/do.png', code: 'DO' },
  { id: 'trinidad', name: 'TRINIDAD & TOBAGO', flag: 'https://flagcdn.com/w160/tt.png', code: 'TT' },
  { id: 'west-indies', name: 'WEST INDIES', flag: 'https://upload.wikimedia.org/wikipedia/commons/thumb/1/18/WestIndiesCricketFlagPre1999.svg/320px-WestIndiesCricketFlagPre1999.svg.png', code: 'WI' },
  { id: 'guatemala', name: 'GUATEMALA', flag: 'https://flagcdn.com/w160/gt.png', code: 'GT' },
  { id: 'costa-rica', name: 'COSTA RICA', flag: 'https://flagcdn.com/w160/cr.png', code: 'CR' },
  { id: 'panama', name: 'PANAMA', flag: 'https://flagcdn.com/w160/pa.png', code: 'PA' },
  { id: 'honduras', name: 'HONDURAS', flag: 'https://flagcdn.com/w160/hn.png', code: 'HN' },
  { id: 'el-salvador', name: 'EL SALVADOR', flag: 'https://flagcdn.com/w160/sv.png', code: 'SV' },
  { id: 'nicaragua', name: 'NICARAGUA', flag: 'https://flagcdn.com/w160/ni.png', code: 'NI' },
  { id: 'belize', name: 'BELIZE', flag: 'https://flagcdn.com/w160/bz.png', code: 'BZ' },
  { id: 'guyana', name: 'GUYANA', flag: 'https://flagcdn.com/w160/gy.png', code: 'GY' },
  { id: 'suriname', name: 'SURINAME', flag: 'https://flagcdn.com/w160/sr.png', code: 'SR' },
  { id: 'barbados', name: 'BARBADOS', flag: 'https://flagcdn.com/w160/bb.png', code: 'BB' },
  { id: 'bahamas', name: 'BAHAMAS', flag: 'https://flagcdn.com/w160/bs.png', code: 'BS' },
  { id: 'grenada', name: 'GRENADA', flag: 'https://flagcdn.com/w160/gd.png', code: 'GD' },
  { id: 'saint-lucia', name: 'SAINT LUCIA', flag: 'https://flagcdn.com/w160/lc.png', code: 'LC' },
  { id: 'antigua', name: 'ANTIGUA & BARBUDA', flag: 'https://flagcdn.com/w160/ag.png', code: 'AG' },
  { id: 'dominica', name: 'DOMINICA', flag: 'https://flagcdn.com/w160/dm.png', code: 'DM' },
  { id: 'saint-kitts', name: 'ST KITTS & NEVIS', flag: 'https://flagcdn.com/w160/kn.png', code: 'KN' },
  { id: 'saint-vincent', name: 'ST VINCENT', flag: 'https://flagcdn.com/w160/vc.png', code: 'VC' },

  // ── AFRICA ──
  { id: 'south-africa', name: 'SOUTH AFRICA', flag: 'https://flagcdn.com/w160/za.png', code: 'ZA' },
  { id: 'nigeria', name: 'NIGERIA', flag: 'https://flagcdn.com/w160/ng.png', code: 'NG' },
  { id: 'egypt', name: 'EGYPT', flag: 'https://flagcdn.com/w160/eg.png', code: 'EG' },
  { id: 'ethiopia', name: 'ETHIOPIA', flag: 'https://flagcdn.com/w160/et.png', code: 'ET' },
  { id: 'kenya', name: 'KENYA', flag: 'https://flagcdn.com/w160/ke.png', code: 'KE' },
  { id: 'ghana', name: 'GHANA', flag: 'https://flagcdn.com/w160/gh.png', code: 'GH' },
  { id: 'morocco', name: 'MOROCCO', flag: 'https://flagcdn.com/w160/ma.png', code: 'MA' },
  { id: 'algeria', name: 'ALGERIA', flag: 'https://flagcdn.com/w160/dz.png', code: 'DZ' },
  { id: 'tunisia', name: 'TUNISIA', flag: 'https://flagcdn.com/w160/tn.png', code: 'TN' },
  { id: 'cameroon', name: 'CAMEROON', flag: 'https://flagcdn.com/w160/cm.png', code: 'CM' },
  { id: 'ivory-coast', name: "IVORY COAST", flag: 'https://flagcdn.com/w160/ci.png', code: 'CI' },
  { id: 'senegal', name: 'SENEGAL', flag: 'https://flagcdn.com/w160/sn.png', code: 'SN' },
  { id: 'tanzania', name: 'TANZANIA', flag: 'https://flagcdn.com/w160/tz.png', code: 'TZ' },
  { id: 'uganda', name: 'UGANDA', flag: 'https://flagcdn.com/w160/ug.png', code: 'UG' },
  { id: 'zimbabwe', name: 'ZIMBABWE', flag: 'https://flagcdn.com/w160/zw.png', code: 'ZW' },
  { id: 'zambia', name: 'ZAMBIA', flag: 'https://flagcdn.com/w160/zm.png', code: 'ZM' },
  { id: 'angola', name: 'ANGOLA', flag: 'https://flagcdn.com/w160/ao.png', code: 'AO' },
  { id: 'mozambique', name: 'MOZAMBIQUE', flag: 'https://flagcdn.com/w160/mz.png', code: 'MZ' },
  { id: 'madagascar', name: 'MADAGASCAR', flag: 'https://flagcdn.com/w160/mg.png', code: 'MG' },
  { id: 'sudan', name: 'SUDAN', flag: 'https://flagcdn.com/w160/sd.png', code: 'SD' },
  { id: 'south-sudan', name: 'SOUTH SUDAN', flag: 'https://flagcdn.com/w160/ss.png', code: 'SS' },
  { id: 'libya', name: 'LIBYA', flag: 'https://flagcdn.com/w160/ly.png', code: 'LY' },
  { id: 'mali', name: 'MALI', flag: 'https://flagcdn.com/w160/ml.png', code: 'ML' },
  { id: 'niger', name: 'NIGER', flag: 'https://flagcdn.com/w160/ne.png', code: 'NE' },
  { id: 'chad', name: 'CHAD', flag: 'https://flagcdn.com/w160/td.png', code: 'TD' },
  { id: 'burkina-faso', name: 'BURKINA FASO', flag: 'https://flagcdn.com/w160/bf.png', code: 'BF' },
  { id: 'guinea', name: 'GUINEA', flag: 'https://flagcdn.com/w160/gn.png', code: 'GN' },
  { id: 'rwanda', name: 'RWANDA', flag: 'https://flagcdn.com/w160/rw.png', code: 'RW' },
  { id: 'somalia', name: 'SOMALIA', flag: 'https://flagcdn.com/w160/so.png', code: 'SO' },
  { id: 'botswana', name: 'BOTSWANA', flag: 'https://flagcdn.com/w160/bw.png', code: 'BW' },
  { id: 'namibia', name: 'NAMIBIA', flag: 'https://flagcdn.com/w160/na.png', code: 'NA' },
  { id: 'congo', name: 'CONGO', flag: 'https://flagcdn.com/w160/cg.png', code: 'CG' },
  { id: 'dr-congo', name: 'DR CONGO', flag: 'https://flagcdn.com/w160/cd.png', code: 'CD' },
  { id: 'sierra-leone', name: 'SIERRA LEONE', flag: 'https://flagcdn.com/w160/sl.png', code: 'SL' },
  { id: 'liberia', name: 'LIBERIA', flag: 'https://flagcdn.com/w160/lr.png', code: 'LR' },
  { id: 'togo', name: 'TOGO', flag: 'https://flagcdn.com/w160/tg.png', code: 'TG' },
  { id: 'benin', name: 'BENIN', flag: 'https://flagcdn.com/w160/bj.png', code: 'BJ' },
  { id: 'gabon', name: 'GABON', flag: 'https://flagcdn.com/w160/ga.png', code: 'GA' },
  { id: 'mauritania', name: 'MAURITANIA', flag: 'https://flagcdn.com/w160/mr.png', code: 'MR' },
  { id: 'eritrea', name: 'ERITREA', flag: 'https://flagcdn.com/w160/er.png', code: 'ER' },
  { id: 'djibouti', name: 'DJIBOUTI', flag: 'https://flagcdn.com/w160/dj.png', code: 'DJ' },
  { id: 'malawi', name: 'MALAWI', flag: 'https://flagcdn.com/w160/mw.png', code: 'MW' },
  { id: 'lesotho', name: 'LESOTHO', flag: 'https://flagcdn.com/w160/ls.png', code: 'LS' },
  { id: 'eswatini', name: 'ESWATINI', flag: 'https://flagcdn.com/w160/sz.png', code: 'SZ' },
  { id: 'gambia', name: 'GAMBIA', flag: 'https://flagcdn.com/w160/gm.png', code: 'GM' },
  { id: 'guinea-bissau', name: 'GUINEA-BISSAU', flag: 'https://flagcdn.com/w160/gw.png', code: 'GW' },
  { id: 'cape-verde', name: 'CAPE VERDE', flag: 'https://flagcdn.com/w160/cv.png', code: 'CV' },
  { id: 'mauritius', name: 'MAURITIUS', flag: 'https://flagcdn.com/w160/mu.png', code: 'MU' },
  { id: 'seychelles', name: 'SEYCHELLES', flag: 'https://flagcdn.com/w160/sc.png', code: 'SC' },
  { id: 'comoros', name: 'COMOROS', flag: 'https://flagcdn.com/w160/km.png', code: 'KM' },
  { id: 'equatorial-guinea', name: 'EQUATORIAL GUINEA', flag: 'https://flagcdn.com/w160/gq.png', code: 'GQ' },
  { id: 'central-african-rep', name: 'CENTRAL AFR. REP.', flag: 'https://flagcdn.com/w160/cf.png', code: 'CF' },
  { id: 'burundi', name: 'BURUNDI', flag: 'https://flagcdn.com/w160/bi.png', code: 'BI' },
  { id: 'sao-tome', name: 'SÃO TOMÉ & PRÍNCIPE', flag: 'https://flagcdn.com/w160/st.png', code: 'ST' },

  // ── OCEANIA ──
  { id: 'australia', name: 'AUSTRALIA', flag: 'https://flagcdn.com/w160/au.png', code: 'AU' },
  { id: 'new-zealand', name: 'NEW ZEALAND', flag: 'https://flagcdn.com/w160/nz.png', code: 'NZ' },
  { id: 'papua-new-guinea', name: 'PAPUA NEW GUINEA', flag: 'https://flagcdn.com/w160/pg.png', code: 'PG' },
  { id: 'fiji', name: 'FIJI', flag: 'https://flagcdn.com/w160/fj.png', code: 'FJ' },
  { id: 'solomon-islands', name: 'SOLOMON ISLANDS', flag: 'https://flagcdn.com/w160/sb.png', code: 'SB' },
  { id: 'vanuatu', name: 'VANUATU', flag: 'https://flagcdn.com/w160/vu.png', code: 'VU' },
  { id: 'samoa', name: 'SAMOA', flag: 'https://flagcdn.com/w160/ws.png', code: 'WS' },
  { id: 'tonga', name: 'TONGA', flag: 'https://flagcdn.com/w160/to.png', code: 'TO' },
  { id: 'kiribati', name: 'KIRIBATI', flag: 'https://flagcdn.com/w160/ki.png', code: 'KI' },
  { id: 'micronesia', name: 'MICRONESIA', flag: 'https://flagcdn.com/w160/fm.png', code: 'FM' },
  { id: 'palau', name: 'PALAU', flag: 'https://flagcdn.com/w160/pw.png', code: 'PW' },
  { id: 'marshall-islands', name: 'MARSHALL ISLANDS', flag: 'https://flagcdn.com/w160/mh.png', code: 'MH' },
  { id: 'nauru', name: 'NAURU', flag: 'https://flagcdn.com/w160/nr.png', code: 'NR' },
  { id: 'tuvalu', name: 'TUVALU', flag: 'https://flagcdn.com/w160/tv.png', code: 'TV' },
];

const ARENA_FULL_THRESHOLD = 50; // Game ends when total balls reach this (arena getting crowded)
const ARENA_RADIUS = 43; // percentage from center (larger arena)

// Difficulty Settings - affects ball speed and collision
const DIFFICULTY_SETTINGS = {
  easy: { speed: 0.6, collisionMultiplier: 1.3, name: 'Easy', icon: '😊' },
  medium: { speed: 0.9, collisionMultiplier: 1.0, name: 'Medium', icon: '😐' },
  hard: { speed: 1.3, collisionMultiplier: 0.7, name: 'Hard', icon: '😈' }
};

// Arena Shapes
const ARENA_SHAPES = [
  { id: 'circle', name: 'Circle', icon: '⭕' },
  { id: 'square', name: 'Square', icon: '⬜' }
];

// Theme Options
const THEMES = [
  { 
    id: 'dark', 
    name: 'Classic Dark', 
    icon: '🌙',
    bgGradient: 'linear-gradient(135deg, #0a0a0a 0%, #1a1a2e 50%, #0a0a0a 100%)',
    arenaGradient: 'radial-gradient(circle at center, #0a1020 0%, #050810 100%)',
    arenaBorder: '#ff8c00',
    accentColor: '#ff8c00',
    textColor: '#ffffff'
  },
  { 
    id: 'stadium', 
    name: 'Stadium Green', 
    icon: '🏟️',
    bgGradient: 'linear-gradient(135deg, #0d2818 0%, #1a4d2e 50%, #0d2818 100%)',
    arenaGradient: 'radial-gradient(circle at center, #1a3d28 0%, #0a1f14 100%)',
    arenaBorder: '#4ade80',
    accentColor: '#4ade80',
    textColor: '#ffffff'
  },
  { 
    id: 'royal', 
    name: 'Royal Blue', 
    icon: '👑',
    bgGradient: 'linear-gradient(135deg, #0a0a2e 0%, #1a1a4e 50%, #0a0a2e 100%)',
    arenaGradient: 'radial-gradient(circle at center, #151540 0%, #080820 100%)',
    arenaBorder: '#6366f1',
    accentColor: '#818cf8',
    textColor: '#ffffff'
  },
  { 
    id: 'fire', 
    name: 'Fire Red', 
    icon: '🔥',
    bgGradient: 'linear-gradient(135deg, #1a0a0a 0%, #2e1a1a 50%, #1a0a0a 100%)',
    arenaGradient: 'radial-gradient(circle at center, #2a1515 0%, #150808 100%)',
    arenaBorder: '#ef4444',
    accentColor: '#f87171',
    textColor: '#ffffff'
  },
  { 
    id: 'gold', 
    name: 'Golden Glory', 
    icon: '✨',
    bgGradient: 'linear-gradient(135deg, #1a1508 0%, #2e2510 50%, #1a1508 100%)',
    arenaGradient: 'radial-gradient(circle at center, #2a2010 0%, #151008 100%)',
    arenaBorder: '#fbbf24',
    accentColor: '#fcd34d',
    textColor: '#ffffff'
  },
  { 
    id: 'neon', 
    name: 'Neon Night', 
    icon: '💜',
    bgGradient: 'linear-gradient(135deg, #0a0a1a 0%, #1a0a2e 50%, #0a0a1a 100%)',
    arenaGradient: 'radial-gradient(circle at center, #150a25 0%, #080510 100%)',
    arenaBorder: '#a855f7',
    accentColor: '#c084fc',
    textColor: '#ffffff'
  },
];


export { DEFAULT_COUNTRIES, ARENA_FULL_THRESHOLD, ARENA_RADIUS, DIFFICULTY_SETTINGS, ARENA_SHAPES, THEMES };
